// extracted by mini-css-extract-plugin
module.exports = {"values":"MultipleSelect_values__5Ihdl","value":"MultipleSelect_value__2EZ0W","label":"MultipleSelect_label__36vqn","close":"MultipleSelect_close__3EGHt"};